import { all, call, take, takeLatest, fork, put } from 'redux-saga/effects'
import { isLoading } from 'domain/loading'
import * as J from 'domain/candidate/jobs'
import * as L from 'domain/locations'

export function* jobsList() {
  yield all([fork(getJobsList), fork(initialLoad), fork(saveJobFromList)])
}

function* getJobsList() {
  yield takeLatest(J.jobsList.type, J.ensureGetJobs)
  yield take(J.jobsList.success)
}

function* saveJobFromList() {
  yield takeLatest(J.saveJobFromList.type, J.ensureAddJobToFavoriteFromList)
  yield take(J.saveJobFromList.success)
}

function* initialLoad() {
  yield put({ type: isLoading, payload: true })
  try {
    // Initial load with 25 jobs per page
    yield all([
      call(J.ensureGetJobs, { payload: { page: 1, perPage: 25 } }),
      call(L.ensureGetCounties)
    ])
    yield put({ type: 'profile/CLEAR_CITIES' })
  } finally {
    yield put({ type: isLoading, payload: false })
  }
}
